import React, { useState, useEffect } from 'react';
import { Input, Button, Row, Col } from 'antd';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import _ from 'lodash';

const NumberInput = ({ value, minValue = 0, maxValue = 100, step = 5, onSubmit }) => {
  const [currentValue, setCurrentValue] = useState(value);

  // Handle change and debounce onSubmit
  useEffect(() => {
    const debouncedSubmit = _.debounce(onSubmit, 300);
    debouncedSubmit(currentValue);
    return () => debouncedSubmit.cancel();
  }, [currentValue, onSubmit]);

  const handleIncrement = () => {
    if (currentValue + step <= maxValue) {
      setCurrentValue(currentValue + step);
    }
  };

  const handleDecrement = () => {
    if (currentValue - step >= minValue) {
      setCurrentValue(currentValue - step);
    }
  };

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);
    if (!isNaN(newValue) && newValue >= minValue && newValue <= maxValue) {
      setCurrentValue(newValue);
    }
  };

  return (
    <Row align="middle" gutter={8} style={{ display: 'flex', justifyContent: 'center' }}>
      <Col>
        <Button icon={<MinusOutlined />} onClick={handleDecrement} />
      </Col>
      <Col>
        <Input
          type="number"
          value={currentValue}
          onChange={handleChange}
          style={{ width: '100px', textAlign: 'center' }}
        />
      </Col>
      <Col>
        <Button icon={<PlusOutlined />} onClick={handleIncrement} />
      </Col>
    </Row>
  );
};

export default NumberInput;
